var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"desktop"},[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',{staticClass:"mb-4"},[_vm._v("Рабочий стол")]),_c(_vm.desktop,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }